import { LucideIcon } from 'lucide-react';
import React from 'react';

import { Card, CardContent } from '../ui/Card';

interface MetricCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: LucideIcon;
  trend?: {
    value: number;
    isPositive: boolean;
    label?: string;
  };
  onClick?: () => void;
  className?: string;
}

export function MetricCard({
  title,
  value,
  subtitle,
  icon: Icon,
  trend,
  onClick,
  className = '',
}: MetricCardProps) {
  const cardContent = (
    <Card
      className={`
        bg-[#221F1F] border-[#504A4A] transition-all duration-200
        ${onClick ? 'cursor-pointer hover:border-[#9B1421] hover:shadow-lg' : ''}
        ${className}
      `}
      onClick={onClick}
    >
      <CardContent className="!p-6">
        <div className="flex items-start justify-between gap-4">
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-white/80 mb-1">{title}</p>
            <div className="flex items-baseline gap-2">
              <p className="text-3xl font-bold text-[#EBFFEE]">{value}</p>
              {trend && (
                <span
                  className={`text-sm font-semibold ${
                    trend.isPositive ? 'text-green-400' : 'text-red-400'
                  }`}
                >
                  {trend.isPositive ? '↑' : '↓'} {Math.abs(trend.value)}%
                  {trend.label && <span className="text-white/80 ml-1">{trend.label}</span>}
                </span>
              )}
            </div>
            {subtitle && (
              <p className="text-xs text-white/80 mt-2">{subtitle}</p>
            )}
          </div>
          {Icon && (
            <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center p-3 bg-[#363232] rounded-lg">
              <Icon className="w-6 h-6 text-text-primary" />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );

  return cardContent;
}

